// Configuration for auth middleware routes
export const AUTH_MIDDLEWARE_ROUTES = [
  '/home',
  // '/trips', 
  // '/timeline',
  '/history',
  '/reports',
  '/updateStatus',
  // '/all-tracker',
  // '/advance-analytics',
  // '/epod',
  // '/consents',
  // '/page'
];

// Routes that should be excluded from auth middleware
export const EXCLUDED_ROUTES = [
  '/login',
  '/logout',
  '/forgot-password',
  '/otp-verification',
  '/public',
  // '/history'
];

// Configuration object for auth middleware
export const AUTH_MIDDLEWARE_CONFIG = {
  // Routes where middleware should apply
  routes: AUTH_MIDDLEWARE_ROUTES,
  
  // Routes to exclude
  excludedRoutes: EXCLUDED_ROUTES,
  
  // Query parameter names to look for
  queryParams: {
    token: 'token',
    basicCred: 'basic_cred',
    keycloak: 'keycloak'
  },
  
  // Whether to clean up URL after processing
  cleanUrlAfterProcessing: true,
  
  // Whether to redirect to login on auth failure
  redirectToLoginOnFailure: true,
  
  // Custom error handling
  onAuthError: (error) => {
    console.error('Auth middleware error:', error);
  },
  
  // Custom success handling
  onAuthSuccess: (result) => {
    console.log('Auth middleware success:', result);
  }
};

export default AUTH_MIDDLEWARE_CONFIG; 